<template>
    <div>
        <select ref="selectElement" class="form-control bootstrap-select" :name="name"></select>
    </div>
</template>

<script setup lang="ts">
    import type { IDataSource } from "@/data/dao/service/BaseServiceDao";
    import type { ILinkableEntity } from "@/data/model/Shared";
    import { i18n } from "@/portal/Trans";
    import { Select } from "@/portal/formControls/Select";
    import { onMounted, ref } from "vue";

    const selectedValues = defineModel<string[] | undefined>({
        required: true,
    });

    const props = defineProps<{
        dataSource: IDataSource<ILinkableEntity>;
        name?: string;
    }>();

    const emit = defineEmits<{
        onChange: [values: string[]];
    }>();

    const selectElement = ref<HTMLElement | null>(null);
    let select: Select<ILinkableEntity>;

    onMounted(() => {
        select = Select.createFromSelectWithOptions<ILinkableEntity>({
            $select: $(selectElement.value!),
            dataSource: props.dataSource,
            formatter: (entity) => entity.name,
            lazyInit: true,
            keyProp: "id",
            showAllText: i18n("elements.select.pleaseSelect"),
            multiSelect: true,
        });

        fetchAndInit();
    });

    function fetchAndInit() {
        select.fetchData(() => {
            select.onChange = () => {
                selectedValues.value = select.getValues();

                emit("onChange", select.getValues());
            };

            if (selectedValues.value) {
                const allowedValues = select.getOptions();
                const allowedSelectedValues = selectedValues.value.filter((x) => allowedValues.includes(x));
                select.setValues(allowedSelectedValues);
            }
        });
    }

    async function refreshDataSource() {
        await select.fetchData();
    }

    function setError(hasError: boolean) {
        select.setError(hasError);
    }

    defineExpose({
        refreshDataSource,
        setError,
    });
</script>
